import { useGetIdentity, useRedirect, Loading } from 'react-admin';
import { Dashboard } from './Dashboard';

export const DashboardRedirector = () => {
    const { isLoading, error } = useGetIdentity();
    const redirect = useRedirect();

    if (isLoading) {
        return <Loading />;
    }

    if (error) {
        console.error('Error fetching identity:', error);
        redirect('/login');
        return null;
    }

    return <Dashboard />;
};
